import { z } from 'zod'

import { DateZod } from '../../common'

const BaseRegistrationEventZod = z.object({
  timestamp: DateZod,
})

export const RegistrationEventZod = z.discriminatedUnion('type', [
  BaseRegistrationEventZod.extend({ type: z.literal('createCandidate') }),
  BaseRegistrationEventZod.extend({ type: z.literal('submit') }),
])

export type RegistrationEvent = z.infer<typeof RegistrationEventZod>
